namespace SPA {
	export namespace Realtor {
		export namespace gui {
			export class OwnerSeller {
				public static Build(ownerList: SPA.Contact[], sellerList: SPA.Contact[], ObjectNumber: string = ''): JQuery
				{
					let owner = new SPA.Contact();
					if (ownerList.length === 1) {
						owner = ownerList[0];
					}
					let seller = new SPA.Contact();
					if (sellerList.length === 1) {
						seller = sellerList[0];
					}

					const ownerDisplayView = new SPA.Contacts.DetailDisplayView({model: owner, ObjectNumber, Status: 'owner'});
					const sellerDisplayView = new SPA.Contacts.DetailDisplayView({model: seller, ObjectNumber, Status: 'seller'});

					const html = $('<fieldset class="form-horizontal">')
						.append('<legend>Objekt-Eigentümer/Verkäufer</legend>')
						.append(ui.$$.div().addClass('row')
							.append(
								ui.$$.div().addClass('col-xs-12 col-sm-6')
									.append(
										$('<h4>Objekt-Eigentümer</h4>'),
										ownerDisplayView.render().$el,
									)
							)
							.append(
								ui.$$.div().addClass('col-xs-12 col-sm-6')
									.append(
										$('<h4>Objekt-Verkäufer</h4>'),
										sellerDisplayView.render().$el,
									)
							)
						);

					return $(html);
				}
			}
		}
	}
}
